import InputField from '../../inputs/inputField'

export default function CommentForm({
	formData,
	setFormData,
	requiredFields,
	errorFields,
}: {
	formData: any
	setFormData: (data: any) => void
	requiredFields: any[]
	errorFields: any[]
}) {
	const handleDataChange = (name: string, value: string) => {
		let newData = { ...formData }
		newData[name] = value
		setFormData(newData)
	}

	return (
		<div className="flex w-full flex-col gap-y-2">
			<InputField
				name="title"
				type="text"
				placeholder="Comment title"
				containerWidth="w-full"
				value={formData.title}
				displayRequired={requiredFields.find(field => field.slug == 'title')}
				onChange={e => {
					handleDataChange('title', e.target.value)
				}}
				isError={errorFields.find(
					requiredField => requiredField.slug == 'title',
				)}
			/>
			<InputField
				name="description"
				lines={4}
				placeholder="Add context to this offchain history signature"
				containerWidth="w-full"
				additionalClasses="h-32"
				value={formData.description}
				displayRequired={requiredFields.find(
					field => field.slug == 'description',
				)}
				onChange={e => {
					handleDataChange('description', e.target.value)
				}}
				isError={errorFields.find(
					requiredField => requiredField.slug == 'description',
				)}
			/>
		</div>
	)
}
